<template>
  <div class="btn-group" v-show="pageCount > 0">
    <button type="button" class="btn btn-white" @click.prevent="setPageIndex(value-1)"><i class="fas fa-chevron-left"></i></button>
    <button v-for="pageInfo in pageList" :key="pageInfo.id" :class="{'btn': true,  'btn-white': pageInfo.index!=value, 'btn-primary':pageInfo.index==value}" :disabled="!pageInfo.enabled" @click.prevent="setPageIndex(pageInfo.index)">
      <template>{{pageInfo.display}}</template>
    </button>
    <button type="button" class="btn btn-white" @click.prevent="setPageIndex(value+1)"><i class="fas fa-chevron-right"></i></button>
  </div>
</template>

<script>
export default {
  name: 'PaginatedButtonGroup',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: Number,
    pageCount: Number,
    maxPageDisplayCount: {
      type: Number,
      default: 10
    }
  },
  computed: {
    pageList() {
      let minPageNormalDisplay = Math.max(this.maxPageDisplayCount, 6)
      if(this.pageCount <= minPageNormalDisplay)
        return Array(this.pageCount).fill().map((_,i) => { return { id: i, index: i, enabled: true, display: (i+1) } })

      let startIndex = Math.max(this.value - 2, 2)
      let endIndex = Math.min(startIndex + (minPageNormalDisplay - 6), this.pageCount-2)
      var pageArray = [
        { id: 0, index: 0, enabled: true, display: '1' },
        { id: 1, index: 1, enabled: true, display: '2' }
      ]
      // If the ellipse only replaces exactly 1 button, just display that button instead
      if(startIndex == 3)
        startIndex--
      if(startIndex > 2)
        pageArray.push({ id: 'startsep', index: null, enabled: false, display: '...' })

      pageArray = pageArray.concat(Array(endIndex-startIndex).fill().map((_,i) => { return { id: startIndex+i, index: startIndex+i, enabled: true, display: (startIndex+i+1) } } ))

      // If the ellipse only replaces exactly 1 button, just display that button instead
      if(endIndex+2 == this.pageCount-1)
        pageArray.push({ id: endIndex, index: endIndex, enabled: true, display: (endIndex+1) })
      else if(endIndex+2 < this.pageCount)
        pageArray.push({ id: 'endsep', index: null, enabled: false, display: '...' })

      let startEnd = Math.max(this.pageCount - 2, this.pageCount-endIndex-1)

      pageArray = pageArray.concat(Array(this.pageCount-startEnd).fill().map((_,i) => { return { id: startEnd+i, index: startEnd+i, enabled: true, display: (startEnd+i+1) } }))
      return pageArray
    }
  },
  methods: {
    setPageIndex(index) {
      if(index === null || index < 0 || index >= this.pageCount)
        return

      this.$emit('update', index)
    }
  }


}
</script>